import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import EvaIcons from "vue-eva-icons";
import VueMeta from 'vue-meta';

Vue.config.productionTip = false;
Vue.use(EvaIcons);
Vue.use(VueMeta);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
